export const mobileMQ = "(max-width: 400px)";
export const microMQ = "(max-width: 185px)";